import { Grid } from '@mui/material';
import { FC, useState } from 'react';
import {
  NeighborhoodLotsDropdown,
  FiltersButtons,
  FiltersLayout,
  SearchField
} from '../../../components';
import { SalesNeighborhoodAutoComplete } from '../../../components/dropdowns/sales-neighborhood-autocomplete';
import { ClosingDateLockedDropdown } from '../../../components/dropdowns/sales-neighborhood-closing-date-locked-dropdown';
import { UnderContractStatusAutoComplete } from '../../../components/dropdowns/under-contract-status-autocomplete';

interface IUnderContractFilters {
  isLoading: boolean;
  applyFilters: (clearFilters?: boolean) => void;
  selectedLotId: string;
  setSelectedNeighborhoodId: (val: any) => void;
  setSelectedLotId: (val: any) => void;
  selectedNeighborhoodId: string[];
  closingDateLocked: boolean | undefined;
  setClosingDateLocked: (val: boolean | undefined) => void;
  setSelectedStatuses?: (val: any) => void;
  selectedStatuses?: string[];
  handleSearch?: (val: string) => void;
  searchPlaceholder?: string;
  searchValue?: string;
  setSearchValue?: (val: string) => void;
  setPage?: (val: number) => void;
  hasAppliedFiltersGlobal?: boolean;
  showHiddenBuilds?: boolean;
  setShowHiddenBuilds?: (val: boolean) => void;
  handleSwitchChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const UnderContractFilters: FC<IUnderContractFilters> = ({
  isLoading,
  applyFilters,
  selectedNeighborhoodId,
  selectedLotId,
  setSelectedNeighborhoodId,
  closingDateLocked,
  setClosingDateLocked,
  setSelectedLotId,
  setSelectedStatuses,
  selectedStatuses,
  setSearchValue,
  searchValue,
  searchPlaceholder = 'Search...',
  handleSearch,
  hasAppliedFiltersGlobal
}) => {
  const [hasAppliedFilters, setHasAppliedFilters] = useState<boolean>(hasAppliedFiltersGlobal);

  return (
    <FiltersLayout alignItems="flex-start">
      {handleSearch && (
        <Grid item xs={12} sm={6} md={6} lg={6}>
          <SearchField
            isDisabled={isLoading}
            placeholder={searchPlaceholder}
            handleSearch={() => {
              setHasAppliedFilters(true);
              applyFilters();
              handleSearch(searchValue);
            }}
            handleClearSearch={() => {
              setSearchValue('');
              handleSearch('');
            }}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={6} md={6} lg={6}>
        <ClosingDateLockedDropdown
          value={closingDateLocked}
          handleChange={setClosingDateLocked}
          inputLabel="Closing Date Status"
          isDisabled={isLoading}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6}>
        <SalesNeighborhoodAutoComplete
          isDisabled={isLoading}
          value={selectedNeighborhoodId}
          handleChange={value => {
            setSelectedNeighborhoodId(value);
            if (Array.isArray(value) && value.length !== 1) {
              setSelectedLotId(''); // Clear selected lot when multiple neighborhoods are selected
            }
          }}
          apiParams={{ ForAgentNewBuilds: true }}
          handleClear={() => {
            setSelectedNeighborhoodId([]); // Ensure state is cleared when "x" is clicked
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6}>
        <NeighborhoodLotsDropdown
          value={selectedLotId}
          isDisabled={!selectedNeighborhoodId || selectedNeighborhoodId.length !== 1 || isLoading}
          handleChange={value => setSelectedLotId(value)}
          apiParams={{
            neighborhoodId: selectedNeighborhoodId,
            includeGeneralJob: false,
            underContractBuildsOnly: true
          }}
          isEnabled={selectedNeighborhoodId.length === 1}
          shouldConvertArray={true}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6}>
        <UnderContractStatusAutoComplete
          isDisabled={isLoading}
          value={selectedStatuses}
          handleChange={value => {
            setSelectedStatuses(value);
          }}
          handleClear={() => {
            setSelectedStatuses([]);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={12} lg={12}>
        <FiltersButtons
          hasAppliedFilters={hasAppliedFilters}
          isDisabled={isLoading}
          handleApplyFilters={() => {
            setHasAppliedFilters(true);
            applyFilters();
          }}
          handleResetFilters={() => {
            setHasAppliedFilters(false);
            setSelectedNeighborhoodId([]);
            setSelectedLotId('');
            setClosingDateLocked(undefined);
            setSelectedStatuses([]);
            applyFilters(true);
          }}
        />
      </Grid>
    </FiltersLayout>
  );
};
